import React from 'react';
import TitleText from '../../../../Components/TitleText/TitleText';
import "./OurServices.css"

const OurServices = () => {
    return (
        <div>

            <div id="services" className="container  my-5
            ">

                <div className="row justify-content-md-center">

                    <TitleText title1="Our" title2="Services" position="center" />
                    <div data-aos="fade-in" data-aos-duration="3000" className="col-md-12 col-sm-12 col-lg-4 mb-2">
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img className='serviceImage' src="https://images.pexels.com/photos/1974596/pexels-photo-1974596.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" />
                                    <div className="centered">Architectural Design</div>


                                </div>
                                <div className="flip-card-back  ">
                                    <h3 className='cardWrittings'>Architectural Design</h3>
                                    <p className='cardWrittings'>The architectural design of Limit Design Ltd is focused on creating beautiful and functional spaces that are tailored to our clients' needs. We use the latest design software and tools to create innovative and sustainable designs, while also paying close attention to detail to ensure that every project exceeds our clients' expectations.
                                    </p>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div data-aos="fade-in" data-aos-duration="3000" className="col-md-12 col-sm-12 col-lg-4  mb-2">
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img className='serviceImage' src="https://i.pinimg.com/564x/6c/ac/1d/6cac1d4749db6aa0bbe080d954c84e62.jpg" alt="" />
                                    <div className="centered">Interior Design</div>

                                </div>
                                <div className="flip-card-back  ">
                                    <h3 className='cardWrittings'>Interior Design</h3>
                                    <p className='cardWrittings'>The interior design of Limit Design Ltd is all about creating spaces that are not only visually appealing but also highly functional and practical. Our team of experienced interior designers are passionate about what they do and are dedicated to staying up-to-date with the latest trends and technologies in the industry.

                                    </p>

                                </div>
                            </div>
                        </div>

                    </div>
                    {/* <div data-aos="fade-in" data-aos-duration="3000" className="col-md-12 col-sm-12 col-lg-4 mb-2  ">
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img className='serviceImage' src="https://i.pinimg.com/564x/03/bc/25/03bc251f79a8621ce7af81b0584715b2.jpg" alt="" />
                                    <div className="centered">Urban Design</div>

                                </div>
                                <div className="flip-card-back  ">
                                    <h3 className='cardWrittings'>Urban Design</h3>
                                    <p className='cardWrittings'>At Limit Design Ltd, we understand that urban design plays a critical role in shaping the world we live in. Our team of urban designers and planners work collaboratively with our clients to create sustainable and livable urban spaces that meet the needs of communities and promote economic growth.

                                    </p>

                                </div>
                            </div>
                        </div>

                    </div> */}


                </div>


            </div>
        </div >

    );
};

export default OurServices;